export function getTextFontFamily() {
  return 'Lato'
}
